









































import _ from 'lodash'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CompanyRepresentativeReport } from '@/utils/Interfaces'
import BaoCaoPLDGNDD from './BaoCaoPLDGNDD.vue'

@Component({
  components: {
    BaoCaoPLDGNDD,
  }
})
export default class DanhGiaNDDDuLieuBaoCao extends Vue {
  @Prop(Boolean) readonly loading!: boolean
  @Prop(Array) readonly companyRepresentativeReports!: Array<CompanyRepresentativeReport>

  get hasReports () {
    return (
      this.companyRepresentativeReports.length > 0
    )
  }

  // ============================================================================

  reportType = 'PLDGNDD'
  reportTypes = ['PLDGNDD']

  get tab () {
    return _.indexOf(this.reportTypes, this.reportType)
  }
  set tab (index) {
    this.reportType = this.reportTypes[index]
  }

  // ============================================================================

  get currentComponent () {
    const mapper: { [index: string]: unknown } = {
      'PLDGNDD': BaoCaoPLDGNDD,
    }
    const component = mapper[this.reportType]
    return component
  }

  get currentReports () {
    const mapper: { [index: string]: unknown } = {
      'PLDGNDD': this.companyRepresentativeReports,
    }
    const reports = mapper[this.reportType]
    return reports
  }
}
